import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {ReglasService} from "../../../services/reglas.service";
import {regla} from "../../../models/regla";
import {zona} from "../../../models/zona";
import {Localiser} from "../../../services/localiser";

@Component({
  selector: 'app-delete-regla',
  templateUrl: './delete-regla.component.html',
  styleUrls: ['./delete-regla.component.css']
})
export class DeleteReglaComponent implements OnInit {
  deleteRegla: regla;
  zonas: zona[];

  constructor(public dialogRef: MatDialogRef<DeleteReglaComponent>,
              private reglasService: ReglasService,
              public localiser: Localiser) { }

  ngOnInit(): void {
    this.deleteRegla = this.reglasService.getDeleteRegla();
    this.zonas = this.deleteRegla.zonas;
  }

  deleteSimple() {
    this.reglasService.deleteSimple(this.deleteRegla.idRegla).subscribe(result => {
      this.dialogRef.close();
    }, error => {
      this.dialogRef.close();
    });
  }

  getZonaById(idZona: string) {
    for (let zona of this.zonas) {
      if (zona.id == idZona) {
        return zona.nombre;
      }
    }
  }

  getDateFromString(dateString: string) {
    let date = new Date(+dateString);
    let day = date.getDate().toString();
    if (date.getDate().toString().length == 1) {
      day = "0" + date.getDate();
    }
    let monthI = date.getMonth() + 1;
    let month = monthI.toString();
    if (month.length == 1) {
      month = "0" + month;
    }
    let hour = date.getHours().toString();
    if (date.getHours().toString().length == 1) {
      hour = "0" + date.getHours();
    }
    let minutes = date.getMinutes().toString();
    if (date.getMinutes().toString().length == 1) {
      minutes = "0" + date.getMinutes();
    }
    return day + "/" + month + "/" + date.getFullYear() + " " + hour + ":" + minutes;
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
